import { useEffect, useState } from "react";
import "../Css/DetailsPage.css";
import { ConfigProvider, Divider, Tabs } from "antd";
import { useParams } from "react-router-dom";
import { get } from "../services/ApiRouting";

import VendorRight from "../Component/VendorDetails/VendorRight";
import VendorLeft from "../Component/VendorDetails/VendorLeft";
import About from "../Component/VendorDetails/About";
import Features from "../Component/VendorDetails/Features";
import Events from "../Component/VendorDetails/Events";
import Religions from "../Component/VendorDetails/Religions";
import FAQ from "../Component/VendorDetails/FAQ";
import Reviews from "../Component/VendorDetails/Reviews";
import Contact from "../Component/VendorDetails/Contact";
import ContactForm from "./ContactForm";
import Policy from "../Component/VendorDetails/Policy";

const DetailsPage = () => {
  const { vendorSlug } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [VenuesDetails, setDetailsList] = useState([]);

  const venuesDetailsFetch = async () => {
    try {
      const response = await get(`vendors?slug=${vendorSlug}`);

      setDetailsList(response.data[0] ?? []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      venuesDetailsFetch();
    }, 300);

    return () => clearTimeout(dbounce);
  }, [vendorSlug]);

  const [activeKey, setActiveKey] = useState("1");
  const [items, setItems] = useState([
    {
      label: "About",
      key: "1",
    },
    {
      label: "Features",
      key: "2",
    },
    {
      label: "FAQ",
      key: "3",
    },
    {
      label: "Reviews",
      key: "4",
    },
    {
      label: "Contact",
      key: "5",
    },
    {
      label: "Policy",
      key: "6",
    },
  ]);

  return (
    <>
      <section className="venues-service-details-page-section">
        <div className="container">
          <div className="venues-service-details-page-section-main-con">
            <div className="row">
              <div className="col-lg-8">
                <VendorLeft VenuesDetails={VenuesDetails} vendorSlug={vendorSlug} />
                <ConfigProvider
                  theme={{
                    components: {
                      Tabs: {
                        colorBgContainer: "var(--primaryColor)",
                        itemColor: "var(--primaryColor)",
                        cardBg: "white",
                        inkBarColor: "white",
                        itemSelectedColor: "white",
                        colorPrimaryHover: "var(--primaryColor)",
                      },
                    },
                  }}
                >
                  <Tabs
                    type="card"
                    activeKey={activeKey}
                    items={items}
                    onChange={setActiveKey}
                  />
                </ConfigProvider>
                <div className="d-block d-lg-none">
                  <VendorRight VenuesDetails={VenuesDetails} />
                </div>
                <About VenuesDetails={VenuesDetails} />
                <Divider />
                <Features VenuesDetails={VenuesDetails} />
                <Events VenuesDetails={VenuesDetails} />
                <Religions VenuesDetails={VenuesDetails} />
                <Divider />
                <FAQ VenuesDetails={VenuesDetails} />
                <Divider />
                <Reviews venuesDetailsFetch={venuesDetailsFetch} VenuesDetails={VenuesDetails} />
                <Divider />
                <Contact VenuesDetails={VenuesDetails} />
                <ContactForm />
                <Policy VenuesDetails={VenuesDetails} />
                <br />
              </div>
              <div className="col-lg-4">
                <div className="d-none d-lg-block" style={{ top: "50px" }}>
                  <VendorRight VenuesDetails={VenuesDetails} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DetailsPage;
